module.exports = __webpack_public_path__ + "img/farzana-christopher-146.bd989b87.jpg";